export function roundCurrency(value: number): number {
  return Math.round(value * 10000) / 10000;
}

export function formatCurrency(amount: number, currencyCode: string = 'GBP'): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
